import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {},
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    storeProfileData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { storeProfileData } = profileSlice.actions;
export default profileSlice.reducer;
